import { useContext } from 'react'

import { AuthSessionContext, defaultAuthSessionValue } from './AuthSessionContext'
import type { AuthSessionValue } from './types'

export function useAuthSession(): AuthSessionValue {
  return useContext(AuthSessionContext) ?? defaultAuthSessionValue
}

/** True while Firebase auth or access snapshot is not yet settled. */
export function useAuthSessionLoading(): boolean {
  return useAuthSession().status === 'loading'
}
